<script>
import MoveTimerSlideItem from './MoveTimerSlideItem.vue'
import InstructionSlideItem from './InstructionSlideItem.vue'
import MoveRepsSlideItem from './MoveRepsSlideItem.vue'

export default {
    name: 'DynamicSlideItem',
    props: ['item'],
    components: {
        MoveTimerSlideItem,
        InstructionSlideItem,
        MoveRepsSlideItem
    },
    computed: {
        renderComponent(){
            const item = this.item
            if (item.type === 'move' && item.circuit_type === 'timer') {
                return 'move-timer-slide-item'
            }
            else if (item.type === 'move' && item.circuit_type === 'reps') {
                return 'move-reps-slide-item'
            }else {
                return 'instruction-slide-item'
            }
        }
    }
};
</script>
<style scoped>
    .content-slide{
        background-color: #000;
    }
</style>
<template>
    <div class="content-slide">
        <component v-bind:is="renderComponent" :item="item"></component>
    </div>
</template>